import { fromJS } from 'immutable';

import { INIT, SUBMIT_SUCCESS, SUBMIT_FAILED, RESET_DIALOG } from './constants';

export const initialState = fromJS({
  submitDone: false,
  errorCode: undefined,
  success: false,
});

function resetPasswordReducer(state = initialState, action) {
  switch (action.type) {
    case INIT:
      return initialState.merge({ submitDone: false, success: false });

    case SUBMIT_SUCCESS:
      return state.merge({ submitDone: true, success: true });

    case SUBMIT_FAILED:
      return state.merge({ submitDone: true, errorCode: action.errorCode });

    case RESET_DIALOG:
      return state.merge({ submitDone: false, errorCode: undefined });

    default:
      return state;
  }
}

export default resetPasswordReducer;
